import { Badge } from 'primereact/badge'
import React from 'react'
import './data.scss'

type BadgeSeverityType = 'success' | 'info' | 'warn' | 'error'

interface BadgePositionedProps {
    iconName: string
    severity?: BadgeSeverityType
    className?: string
    value?: string
    size?: number
}

const BadgePositioned = ({
    iconName,
    severity,
    className,
    value,
    size,
}: BadgePositionedProps) => {
    let icon = ''
    switch (iconName) {
        case 'check_circle':
            icon = 'check-circle'
            break
        case 'public':
            icon = 'globe'
            break
        case 'warning':
            icon = 'exclamation-triangle'
            break
        case 'cancel':
            icon = 'times-circle'
            break
        case 'camera_alt':
            icon = 'camera'
            break
        default:
            icon = iconName
            break
    }

    return (
        <i
            className={`pi ${icon} p-overlay-badge ${className} badge-positioned`}
            style={{ fontSize: size ? size + 'px' : '22px' }}>
            <Badge severity={severity} value={value}></Badge>
        </i>
    )
}

export default BadgePositioned
